<div class="container">
  <form class="reset-form">
    <!-- <div class="title">Forget Password</div> -->
     <div class="title">
  {{ isMr ? 'पासवर्ड विसरलात' : 'Forgot Password' }}
</div>

    <!-- Email Address -->
    <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top">
      <dxi-form-item dataField="email" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
placeholder: this.isMr ? 'तुमचा ईमेल टाका' : 'Enter your email',
              buttons: [{
                name: 'userIcon',
                location: 'after',
                options: { icon:'custom-user-icon' }
              }]
            }">
        <!-- <dxo-label text="Email Id"></dxo-label> -->
         <dxo-label [text]="isMr ? 'ईमेल आयडी' : 'Email Id'"></dxo-label>
      </dxi-form-item>
    </dx-form>

    <div class="centre">
      <dx-button  [text]="isMr ? 'ओटीपी पाठवा' : 'Send OTP'" type="default" stylingMode="contained" class="send-otp-button"
        (click)="VerifyEmail($event)"></dx-button>
    </div>

    <!-- Verify OTP  -->
    <div class="centre" style="gap: 1.5vw; margin-top: 25px; flex-wrap: wrap;">
      <!-- OTP Input -->
      <div style="flex: 1; min-width: 200px; max-width: 250px;">
        <dx-text-box [(value)]="otp" stylingMode="outlined"  [placeholder]="isMr ? 'ओटीपी टाका' : 'Enter OTP'" maxLength="6"
          [inputAttr]="{ inputmode: 'numeric', pattern: '[0-9]*' }" (onInput)="filterDigits($event)"></dx-text-box>
      </div>

      <!-- Verify Button -->
      <div style="min-width: 160px;">
        <dx-button [text]="isMr ? 'ओटीपी पडताळा' : 'Verify OTP'" type="default" stylingMode="contained" (onClick)="VerifyOTP()" width="100%"
          style="background-color: rgb(83, 83, 212); color: white; border-radius: 5px;"></dx-button>
      </div>
    </div>

    <!-- Resend OTP -->
    <p class="centre" style="margin-bottom: 30px; font-size: 13px; flex-wrap: wrap;">
       {{ isMr ? 'कोड मिळाला नाही?' : "Haven't received the code?" }} &nbsp;
      <a class="label2" style="color: #f75c01; font-size: 13px;"
        [style.cursor]="isResendOtpDisabled ? 'not-allowed' : 'pointer'"
        [style.textDecoration]="!isResendOtpDisabled ? 'underline' : 'none'"
        (onClick)="ResendOtp()">
       {{ isMr ? 'पुन्हा पाठवा' : 'Resend here' }}
    {{ isResendOtpDisabled ? '(' + ResendOtpTimer + 's)' : '' }}
      </a>
    </p>

    <!-- Create New Password -->
    <dx-form [formData]="formData" [disabled]="loading" [colCount]="1" labelLocation="top">
      <dxi-form-item dataField="password" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
              placeholder: isMr ? 'नवीन पासवर्ड टाका' : 'Enter your password',
              mode: newpasswordMode,
              buttons: [{
                name: 'togglePassword',
                location: 'after',
                options: {
                  icon: newpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: toggleNewPasswordVisibility
                }
              }]
            }">
        <!-- <dxo-label text="Enter New Password"></dxo-label> -->
         <dxo-label [text]="isMr ? 'नवीन पासवर्ड' : 'Enter New Password'"></dxo-label>
        <dxi-form-validation-rule type="required" message="Password is required"></dxi-form-validation-rule>
      </dxi-form-item>

      <dxi-form-item dataField="ConfirmPassword" editorType="dxTextBox" [editorOptions]="{
              stylingMode: 'outlined',
              placeholder: isMr ? 'पासवर्डची पुष्टी करा' : 'Enter confirm password',
              mode: confirmpasswordMode,
              buttons: [{
                name: 'togglePassword',
                location: 'after',
                options: {
                  icon: confirmpasswordMode === 'text' ? 'custom-eye-open' : 'custom-eye-close',
                  onClick: toggleConfirmPasswordVisibility
                }
              }]
            }">
        <!-- <dxo-label text="Confirm Password"></dxo-label> -->
         [text]="isMr ? 'पासवर्डची पुष्टी' : 'Confirm Password'"
      </dxi-form-item>
    </dx-form>

    <!-- Verify & Save  -->
    <div class="centre" style="justify-content: space-between; flex-wrap: wrap; gap: 10px;">
      <div style="flex: 1; min-width: 150px;">
        <dx-button [text]="isMr ? 'तपासा आणि जतन करा' : 'Verify And Save'" type="default" stylingMode="contained" class="verify-back-button"
          (click)="VerifyPassword()"></dx-button>
      </div>

      <!-- Back To Login -->
      <div style="flex: 1; min-width: 150px;">
        <dx-button [text]="isMr ? 'लॉगिनकडे परत जा' : 'Back To Login'" type="default" stylingMode="contained" class="verify-back-button"
          (click)="BackToLogin()"></dx-button>
      </div>
    </div>
  </form>
</div>
